module.exports = __webpack_public_path__ + "media/images/common/update_order_ov-2ba09022f0cce3a3c4beeba23921714f.png";